/** Persisted game picture IDs are shared across seasons. Never rename them. */
export const gamePictureIds = [
  'gift',
  'cup_one',
  'cup_two',
  'cake',
  'cup_cake',
  'cookie_tree',
  'cookie_star',
  'lollipop',
  'mittens',
  'tree',
  'tree_toys',
  'santa',
  'house_one',
] as const;
export type GamePictureId = (typeof gamePictureIds)[number];
